import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { MatDialog } from '@angular/material/dialog';
import { ComponentType } from '@angular/cdk/portal';
import { TranslateService } from '@ngx-translate/core';
import { DeleteDialogComponent } from '../delete-dialog/delete-dialog.component';
import { FooPaginatedListingDialogComponent } from '../foo-paginated-listing-dialog/foo-paginated-listing-dialog.component';
import { FooPaginatedListingDialogTabsConfigs } from '../foo-paginated-listing-dialog/foo-paginated-listing-dialog-tabs-configs.interface';

interface DialogConfigs {
  data?: any,
  width?: string,
  height?: string,
  panelClass?: string | string[],
  backdropClass?: string | string[]
}

interface FooPaginatedListingDialogConfigs {
  dialogTitle?: string;
  activeTab?: string;
  button?: {
    label?: string;
    class?: string;
  };
  tabsConfigs: FooPaginatedListingDialogTabsConfigs[];
}

@Injectable({
  providedIn: 'root'
})
export class CommonDialogService {

  constructor(protected dialog: MatDialog, protected translate: TranslateService,) { }

  defaultDialogConfigs: DialogConfigs = {
    data: {},
    width: '550px',
    height: '',
    panelClass: ['app-custom-dialog-container', 'display-scrollbar'],
    backdropClass: 'app-customer-backdrop'
  }

  openDialog(
    component: ComponentType<any>,
    configurations?: DialogConfigs
  ): Observable<any> {
    const configs = {...this.defaultDialogConfigs, ...configurations};
    return new Observable<any>(observer => {
      const dialogRef = this.dialog.open(component, {
        width: configs.width,
        height: configs.height,
        panelClass: configs.panelClass,
        backdropClass: configs.backdropClass,
        data: configs.data
      });
      dialogRef.afterClosed().subscribe(confirmed => {
        observer.next(confirmed || false);
        observer.complete();
      });
    });
  };

  openConfirm(
    title: string,
    text: string,
    button?: string,
    buttonClass?: string,
    apiUrl?: string,
    apiParams?: any,
    dialogConfigs?: DialogConfigs,
  ): Observable<boolean> {
    const data = {
      apiUrl: apiUrl,
      apiParams: apiParams,
      title: title,
      text: text,
      button: button ? button : this.translate.instant('general.confirm'),
      buttonClass: buttonClass ? buttonClass : 'foo-btn-primary'
    };
    const configs = {data: data, width: '500px', panelClass: 'app-custom-dialog-container', ...dialogConfigs};
    return this.openDialog(DeleteDialogComponent, configs);
  }

  openDelete(
    apiUrl: string,
    apiParams: any,
    title: string,
    text: string,
    button?: string,
    buttonClass?: string,
    dialogConfigs?: DialogConfigs
  ): Observable<boolean> {
    const data = {
      apiUrl: apiUrl,
      apiParams: apiParams,
      title: title,
      text: text,
      button: button,
      buttonClass: buttonClass
    };
    const configs = {data: data, width: '500px', panelClass: 'app-custom-dialog-container', ...dialogConfigs};
    return this.openDialog(DeleteDialogComponent, configs);
  }

  openFooPaginatedListing(data: FooPaginatedListingDialogConfigs, dialogConfigs?: DialogConfigs): Observable<boolean> {
    const configs = {data: data, width: '500px', ...dialogConfigs};
    return this.openDialog(FooPaginatedListingDialogComponent, configs);
  }
}
